// extracted by mini-css-extract-plugin
module.exports = {"divPpal":"aea-error-table_divPpal__25-bo","indError":"aea-error-table_indError__U4nSY","tdError":"aea-error-table_tdError__31RKX"};